import React from 'react'

export const FailedTickIcon = ({ className, size = 20 }) => {
  return (
    <svg
      className={`icons-12 ${className}`}
      fill="none"
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        className="mask"
        height={size}
        id="mask0_1248_3170"
        maskUnits="userSpaceOnUse"
        width={size}
        x="0"
        y="0"
      >
        <rect className="rect" fill="#D9D9D9" height={size} width={size} />
      </mask>
      <g className="g" mask="url(#mask0_1248_3170)">
        <path
          className="path"
          d="M9.99984 10.7738L12.5607 13.3348C12.6761 13.4501 12.8038 13.5057 12.9438 13.5015C13.0837 13.4972 13.214 13.4347 13.3348 13.314C13.4555 13.1932 13.5159 13.0641 13.5159 12.9269C13.5159 12.7897 13.4555 12.661 13.3348 12.5409L10.7738 9.98942L13.3348 7.43796C13.4501 7.32324 13.5091 7.19588 13.5119 7.05588C13.5146 6.91602 13.4555 6.78567 13.3348 6.66484C13.214 6.54414 13.085 6.4838 12.9478 6.4838C12.8105 6.4838 12.6815 6.54414 12.5607 6.66484L9.99984 9.22588L7.439 6.66484C7.32359 6.54956 7.19935 6.49053 7.0663 6.48775C6.93338 6.48512 6.8065 6.54414 6.68567 6.66484C6.56498 6.78567 6.50463 6.9147 6.50463 7.05192C6.50463 7.18914 6.56442 7.31817 6.684 7.439L9.22588 9.99984L6.66484 12.5607C6.54956 12.6761 6.494 12.8003 6.49817 12.9334C6.50248 13.0663 6.56498 13.1932 6.68567 13.314C6.8065 13.4347 6.93553 13.495 7.07275 13.495C7.20998 13.495 7.33838 13.4353 7.45796 13.3157L9.99984 10.7738ZM10.0069 17.5832C8.96373 17.5832 7.98123 17.3858 7.05942 16.9911C6.13761 16.5964 5.33081 16.0532 4.639 15.3617C3.9472 14.6702 3.4038 13.864 3.0088 12.9432C2.61393 12.0225 2.4165 11.0387 2.4165 9.99171C2.4165 8.94477 2.61387 7.96386 3.00859 7.049C3.40331 6.13414 3.94643 5.33081 4.63796 4.639C5.32949 3.9472 6.13567 3.4038 7.0565 3.0088C7.9772 2.61393 8.96102 2.4165 10.008 2.4165C11.0549 2.4165 12.0358 2.61386 12.9507 3.00859C13.8655 3.40331 14.6689 3.94643 15.3607 4.63796C16.0525 5.32949 16.5959 6.134 16.9909 7.0515C17.3857 7.96914 17.5832 8.94956 17.5832 9.99275C17.5832 11.0359 17.3858 12.0184 16.9911 12.9403C16.5964 13.8621 16.0532 14.6689 15.3617 15.3607C14.6702 16.0525 13.8657 16.5959 12.9482 16.9909C12.0305 17.3857 11.0501 17.5832 10.0069 17.5832ZM9.99984 16.4998C11.8054 16.4998 13.3401 15.8679 14.604 14.604C15.8679 13.3401 16.4998 11.8054 16.4998 9.99984C16.4998 8.19428 15.8679 6.65956 14.604 5.39567C13.3401 4.13178 11.8054 3.49984 9.99984 3.49984C8.19428 3.49984 6.65956 4.13178 5.39567 5.39567C4.13178 6.65956 3.49984 8.19428 3.49984 9.99984C3.49984 11.8054 4.13178 13.3401 5.39567 14.604C6.65956 15.8679 8.19428 16.4998 9.99984 16.4998Z"
          fill="#EF4D4F"
        />
      </g>
    </svg>
  )
}
